export const nhaCungCap = {
  sections: {
    list: { title: 'Suppliers' },
    general: 'General information',
  },
  stats: {
    total: 'Total {count}',
    activeOnPage: 'Active (page): {count}',
    inactiveOnPage: 'Inactive (page): {count}',
  },
  fields: {
    code: 'Supplier code',
    name: 'Supplier name',
    classification: 'Classification',
    phone: 'Phone',
    email: 'Email',
    address: 'Address',
    province: 'Province/City',
    area: 'Area',
    ward: 'Ward',
    groups: 'Supplier groups',
    groupCode: 'Group code',
    groupName: 'Group name',
    note: 'Note',
    companyName: 'Company name',
    taxCode: 'Tax code',
    totalPurchase: 'Total purchase',
    debt: 'Current payable',
    totalPurchaseNet: 'Net purchase',
    branch: 'Branch',
    createdBy: 'Created by',
    onOffAction: 'On / Off',
    status: 'Status',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    actions: 'Actions',
  },
  aria: {
    columnPicker: 'Choose visible columns',
  },
  status: {
    dangHoatDong: 'Active',
    ngungHoatDong: 'Inactive',
    all: 'All',
  },
  sort: {
    maNhaCungCap: 'Code',
    tenNhaCungCap: 'Name',
    ngayTao: 'Created date',
    trangThai: 'Status',
  },
  filter: {
    searchPlaceholder: 'Search',
    textDetailTitle: 'Advanced filters',
    group: 'Group',
    statusSection: 'Status',
    groupSection: 'Supplier group',
    sortSection: 'Sort',
    sortField: 'Sort field',
    sortDir: 'Direction',
  },
  titles: { add: 'Add supplier', edit: 'Edit supplier', detail: 'Supplier detail' },
  placeholders: {
    codeAuto: 'Auto-generated',
    province: 'Select province',
    ward: 'Select ward',
  },
  validation: {
    nameRequired: 'Please enter supplier name',
    phoneInvalid: 'Invalid phone (8–15 digits)',
    emailInvalid: 'Invalid email',
    taxCodeInvalid: 'Invalid tax code (10 or 13 digits)',
  },
  messages: {
    noData: 'No data',
    loadError: 'Failed to load data',
    loadDetailError: 'Failed to load detail',
    createSuccess: 'Supplier created',
    updateSuccess: 'Supplier updated',
    deleteSuccess: 'Supplier deleted',
    toggleSuccess: 'Status updated',
    confirmDelete: 'Delete supplier «{name}»?',
    listSummary: 'Total {count} suppliers',
    selectedCount: 'Selected: {count}',
    deleteSelected: 'Delete selected ({count})',
    bulkDeleteConfirm: 'Delete {count} selected suppliers? (Each supplier is deleted via API.)',
    bulkDeleteSuccess: 'Deleted {count} suppliers',
    bulkDeletePartial: 'Deleted {ok}/{total}. {failed} suppliers could not be deleted.',
    bulkDeleteError: 'Bulk delete failed',
    bulkDeleteNoneSelected: 'No suppliers selected to delete',
  },
  import: {
    description: 'Select an Excel file from the downloaded template. Import is processed on the server.',
    success: 'Suppliers imported successfully',
    failed: 'Supplier import failed',
    capNhatDuNoCuoi: 'Update opening balance debt',
  },
  detailTabs: {
    generalInfo: 'Info',
    debt: 'Payables',
  },
  expandDebt: {
    hint: 'Debt transaction history will appear here.',
  },
}
